import React from 'react'
import { Link } from 'react-router-dom'

const TestIndexPage: React.FC = () => {
  const testPages = [
    {
      title: 'Bank Data Fields Test',
      description: 'Test tất cả các trường dữ liệu từ database trong thư mục public/bank',
      path: '/bank-data-fields-test',
      icon: '🗃️'
    },
    {
      title: 'DS Load Test',
      description: 'Test load database câu hỏi đúng sai (DS)',
      path: '/ds-load-test',
      icon: '✅'
    },
    {
      title: 'DS Schema Test',
      description: 'Đọc và phân tích schema database DS',
      path: '/ds-schema-test',
      icon: '📊'
    },
    {
      title: 'True False Data Test',
      description: 'Test dữ liệu câu hỏi đúng sai qua service',
      path: '/true-false-data-test',
      icon: '🔄'
    },
    {
      title: 'Database Structure Test',
      description: 'Test cấu trúc database tổng quát',
      path: '/database-structure-test',
      icon: '🏗️'
    },
    {
      title: 'Image Display Test',
      description: 'Test hiển thị hình ảnh từ database',
      path: '/image-display-test',
      icon: '🖼️'
    },
    {
      title: 'DS Step-by-Step Test',
      description: 'Debug từng bước xử lý DS questions từ database đến UI',
      path: '/ds-step-test',
      icon: '🔍'
    }
  ]

  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <div className="max-w-6xl mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-8">Test Pages Index</h1>
        <p className="text-gray-600 text-center mb-12">
          Danh sách các trang test để kiểm tra chức năng và dữ liệu
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testPages.map((page, index) => (
            <Link
              key={index}
              to={page.path}
              className="block bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 p-6 border border-gray-200 hover:border-blue-300"
            >
              <div className="text-4xl mb-4">{page.icon}</div>
              <h2 className="text-xl font-semibold mb-3 text-gray-800">
                {page.title}
              </h2>
              <p className="text-gray-600 text-sm leading-relaxed">
                {page.description}
              </p>
              <div className="mt-4 text-blue-600 text-sm font-medium">
                Truy cập test →
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link
            to="/"
            className="btn-primary inline-flex items-center px-6 py-3 rounded-lg"
          >
            ← Về trang chủ
          </Link>
        </div>
      </div>
    </div>
  )
}

export default TestIndexPage